export default __webpack_public_path__ + "static/media/rating-5.0c94c06c.webp";